import DetailPartialsPlaceShoe from "./DetailPartialsPlaceShoe";

export default DetailPartialsPlaceShoe;
